function isPositiveId(id: number): boolean {
  return Number.isInteger(id) && id > 0;
}

export function parsePositiveIdParams<TKey extends string>(
  params: Record<TKey, string>,
): Record<TKey, number> | null {
  const parsedEntries = Object.entries<string>(params).map(
    ([key, value]) => [key, Number(value)] as const,
  );
  if (!parsedEntries.every(([, id]) => isPositiveId(id))) return null;
  return Object.fromEntries(parsedEntries) as Record<TKey, number>;
}
